import "./AlertDialog.scss";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { AlertDialogProps } from "../../models/AlertDialogModel";
import { useTranslation } from "react-i18next";

export const AlertDialog = (props: AlertDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-dialog-container"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={props.handleClose}>
          {props.cancelBtnText || t("opva.cancel")}
        </Button>
        <Button variant="contained" onClick={props.handleSubmit} autoFocus>
          {props.submitBtnText || t("opva.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
